
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CountryModel } from '@/models/country.model';
import { ChallengeSuggestion } from '@/models/challenge-suggestion.model';
import { ChallengeSuggestionsApi } from '@/api/challenge-suggestions.api';
import { take } from 'rxjs/operators';
import { countriesState } from '@/utils/store-acessor';
import { validators } from '@/utils/validations';
import { categoriesModule, categoriesState } from '@/utils/store-acessor';
import { CategoryModel } from '@/models/category.model';

@Component({})
export default class PostChallengeForm extends Vue {
  @categoriesModule.Getter('categories') categories!: CategoryModel[];

  valid: boolean = false;
  values: ChallengeSuggestion = {
    name: '',
    email: '',
    phone: '',
    country_id: -1,
    category_id: -1,
    message: ''
  };

  @Prop({})
  onSubmit!: () => void;

  submitting: boolean = false;

  get countries(): CountryModel[] {
    return countriesState.countries;
  }

  rules = validators;

  async mounted() {
    await categoriesState.fetchCategories();
    await countriesState.requestAllCountries();
  }

  // @Emit('onSubmit')
  handleSubmit() {
    if (this.valid) {
      this.submitting = true;
      new ChallengeSuggestionsApi()
        .create(this.values)
        .pipe(take(1))
        .subscribe(
          res => {
            this.$emit('on-success');
          },
          error => {
            alert('Sorry, we could not process this request. Try again!');
            this.submitting = false;
          }
        );
    }
    return false;
  }
}
